import { render, staticRenderFns } from "./MarketingAutomationList.vue?vue&type=template&id=1bbcb0fc&scoped=true"
import script from "./MarketingAutomationList.vue?vue&type=script&lang=js"
export * from "./MarketingAutomationList.vue?vue&type=script&lang=js"
import style0 from "./MarketingAutomationList.vue?vue&type=style&index=0&id=1bbcb0fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbcb0fc",
  null
  
)

export default component.exports